import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const missions = [
  { icon: 'ri-focus-3-line', titleKey: 'mission.m1.title', descKey: 'mission.m1.desc' },
  { icon: 'ri-eye-line', titleKey: 'mission.m2.title', descKey: 'mission.m2.desc' },
  { icon: 'ri-hand-heart-line', titleKey: 'mission.m3.title', descKey: 'mission.m3.desc' },
];

export default function MissionSection() {
  const { t } = useTranslation('about');
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="w-full bg-cream-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('mission.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-4">
              {t('mission.title')}
            </h2>
            <p className="text-sm md:text-base text-ink-400 max-w-2xl mx-auto leading-relaxed">
              {t('mission.subtitle')}
            </p>
            <div className="w-16 h-1 bg-warm-500 mx-auto mt-6 rounded-full" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {missions.map((item, index) => (
              <div
                key={item.titleKey}
                className={`p-6 md:p-8 bg-white border border-ink-100 rounded-xl transition-all duration-700 ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: `${index * 120}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-warm-50 flex items-center justify-center mb-5">
                  <i className={`${item.icon} text-warm-500 text-2xl`} />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-ink-700 mb-3">
                  {t(item.titleKey)}
                </h3>
                <p className="text-sm text-ink-400 leading-relaxed">{t(item.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}